<template>
  <b-container class="post">
    <loading v-if="!page || loading"></loading>
    <div v-else>
      <router-link :to="{ name: 'page', params: { id: page.pageID }}">Back to posts</router-link>
      <h3>Comments of {{page.name }} posts</h3>
      <b-row class="mt-3">
        <b-col class="text-left">
          <b-button size="sm" variant="light" @click="toggleAllComments">{{ toggleText }}</b-button>
          <b-button size="sm" variant="light" @click="preSelectComments">Select automatically</b-button>
        </b-col>
      </b-row>
      <b-card class="mt-3" no-body v-for="post in page.posts" :key="post.id">
        <template v-slot:header>
          <a :href="post.link">
            <h6>{{post.title}}</h6>
          </a>
        </template>
        <b-list-group flush>
          <b-list-group-item
            class="py-1"
            v-for="comment in post.comments"
            :key="comment.id"
            :class="{ active: toLike.includes(comment) }"
            @click="toLike.includes(comment) ? toLike.splice(toLike.indexOf(comment), 1) : toLike.push(comment)"
          >{{ comment.message }}</b-list-group-item>
        </b-list-group>
      </b-card>
      <b-button class="mt-3" variant="primary" @click="likeComments">Like comments</b-button>
    </div>
  </b-container>
</template>

<script>
import PageService from "@/services/PageService.js";
import Loading from "@/components/Loading";

export default {
  components: {
    Loading
  },
  data() {
    return {
      loading: true,
      page: null,
      toLike: [],
      toggleText: "Select all"
    };
  },
  methods: {
    async getData() {
      const accessToken = await this.$auth.getTokenSilently()
      PageService.getPosts(
        this.$route.params.id,
        this.$route.params.postId,
        accessToken
      ).then(
        (page => {
          this.$set(this, "page", page);
          this.preSelectComments();
          this.loading = false;
        }).bind(this)
      );
    },
    async likeComments() {
      this.loading = true;
      const accessToken = await this.$auth.getTokenSilently()
      let self = this;
      PageService.postLike(this.toLike, this.$route.params.id, accessToken).then(function(
        response
      ) {
        self.$router.push({
          name: "page",
          params: {
            pageId: self.page.pageID,
            alert: { message: response.body, variant: "info" }
          }
        });
        self.loading = false;
      });
    },
    toggleAllComments() {
      if (this.toggleText === "Select all") {
        this.toLike = this.allComments();
        this.toggleText = "Select none";
      } else {
        this.toLike = [];
        this.toggleText = "Select all";
      }
    },
    preSelectComments() {
      let self = this;
      this.toLike = self.allComments().filter(function(comment) {
        return self.matchLikableComment(comment.message);
      });
    },
    allComments() {
      let comments = [];
      for (const post of this.page.posts) {
        comments = comments.concat(post.comments);
      }
      return comments;
    },
    matchLikableComment(comment) {
      let expressions = this.page.regExps;
      for (let i in expressions) {
        if (
          new RegExp(expressions[i], "im").test(comment) &&
          comment.length < 50
        ) {
          return true;
        }
      }
      return false;
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style>
li:hover {
  color: red;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item.active {
  /* background-color: green; */
}
</style>
